import { IDefineCommand } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
import { APTerm } from '../../global/builders/ap_term_builder';
import { IAPPlannedCourseDataSource } from '../../global/datasources/ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from '../../global/datasources/ap_planned_course_group_datasource';
import { APModel } from '../../global/models/ap_model';
import { APCommandUrlServant } from '../../global/servants/ap_command_url_servant';
import { FeedbackSuggestedPlanModel } from '../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'deleteTermCommand',
    function deleteTermCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngAPModel: APModel,
      ngAPCommandUrlServant: APCommandUrlServant,
      ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
      log: any
    ) {
      return defineCommand('deleteTermCommand', function deleteTermCommand(deferred: any, term: APTerm) {
        // TODO: Create servant for getting student/advisor term payload
        const payload = {
          term_id: term.id,
          suggested_plan: ngFeedbackSuggestedPlanModel.read().id
        };

        const academicPlanUrl = ngAPCommandUrlServant.get('academicPlan');

        $http
          .delete(`${academicPlanUrl}/term/`, {
            data: payload
          })
          .then((response: any) => {
            ngAPModel.removePlannedTerm(term.id);

            ngAPPlannedCoursesDatasource.clear().write(response.data.planned_course);

            ngAPPlannedCourseGroupDatasource.clear().write(response.data.planned_course_group);

            deferred.resolve(ORM.run(ngAPPlannedCourseGroupDatasource, ngAPPlannedCoursesDatasource, ngAPModel));
          })
          .catch((e) => {
            log.issue('failed to delete term, please try again');
            deferred.reject(e.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/delete_term_command.ts